import { Injectable } from '@angular/core';
import CurrencyList from 'currency-list';

export interface Currency {
  name: string;
  symbol_native: string;
  symbol: string;
  code: string;
  name_plural: string;
  rounding: number;
  decimal_digits: number;
}

@Injectable({
  providedIn: 'root',
})
export class CurrencyService {
  currencies: Currency[] = [];

  constructor() {
    const currencyList = CurrencyList.getAll('en_US');

    Object.keys(currencyList).forEach((key) => {
      // @ts-ignore
      this.currencies?.push(currencyList[key]);
    });
  }
}
